import React, { useState, useEffect } from 'react';
import { Button, IconButton, Modal, TextField, Snackbar } from '@material-ui/core';
import { Check, Edit, Trash, CirclePlus, X } from 'tabler-icons-react';
import { ParosAutorizadosProvider, useParosAutorizados } from './ParosAutorizadosContext';
import ConfirmModal from '../../components/ConfirmModal';
import '../../styles/capacidades.css';
import '../../App.css';

function NuevoItem() {
    const { nuevo, setNuevo, postItem, errorMsg, setErrorMsg } = useParosAutorizados();
    const [nombre, setNombre] = useState('');
    const [error, setError] = useState('');

    useEffect(() => { if (nuevo) { setNombre(''); setError(''); setErrorMsg(null); } }, [nuevo, setErrorMsg]);

    const handleClose = () => { setNuevo(false); setError(''); setErrorMsg(null); };
    const handleSubmit = () => {
        if (!nombre.trim()) { setError('El nombre es requerido'); return; }
        postItem(nombre.trim());
    };

    return (
        <Modal open={nuevo} onClose={handleClose}>
            <div className="llamada-modal">
                <div className="llamada-modal-header">
                    <h2 className="popuptitle">Nuevo — Paro autorizado</h2>
                    <IconButton size="small" onClick={handleClose}><X size={20} /></IconButton>
                </div>
                <div className="llamada-modal-body">
                    <div className="llamada-step-field">
                        <TextField
                            label="Nombre"
                            value={nombre}
                            onChange={(e) => { setNombre(e.target.value); if (error) setError(''); }}
                            fullWidth autoFocus
                            error={!!error} helperText={error}
                            inputProps={{ maxLength: 80 }}
                        />
                    </div>
                </div>
                {errorMsg && <p className="llamada-modal-error">{errorMsg}</p>}
                <div className="llamada-modal-footer">
                    <Button variant="outlined" color="primary" onClick={handleClose}>Cancelar</Button>
                    <Button variant="contained" color="primary" onClick={handleSubmit}>Guardar</Button>
                </div>
            </div>
        </Modal>
    );
}

function EditarItem() {
    const { editar, setEditar, selectedItem, putItem, errorMsg, setErrorMsg } = useParosAutorizados();
    const [nombre, setNombre] = useState('');
    const [error, setError] = useState('');

    useEffect(() => { if (selectedItem) setNombre(selectedItem.nombre || ''); }, [selectedItem]);

    const handleClose = () => { setEditar(false); setError(''); setErrorMsg(null); };
    const handleSubmit = () => {
        if (!nombre.trim()) { setError('El nombre es requerido'); return; }
        putItem(selectedItem.codigo, nombre.trim());
    };

    return (
        <Modal open={editar} onClose={handleClose}>
            <div className="llamada-modal">
                <div className="llamada-modal-header">
                    <h2 className="popuptitle">Editar — Paro autorizado</h2>
                    <IconButton size="small" onClick={handleClose}><X size={20} /></IconButton>
                </div>
                <div className="llamada-modal-body">
                    <div className="llamada-step-field">
                        <TextField
                            label="Nombre"
                            value={nombre}
                            onChange={(e) => { setNombre(e.target.value); if (error) setError(''); }}
                            fullWidth autoFocus
                            error={!!error} helperText={error}
                            inputProps={{ maxLength: 80 }}
                        />
                    </div>
                </div>
                {errorMsg && <p className="llamada-modal-error">{errorMsg}</p>}
                <div className="llamada-modal-footer">
                    <Button variant="outlined" color="primary" onClick={handleClose}>Cancelar</Button>
                    <Button variant="contained" color="primary" onClick={handleSubmit}>Guardar cambios</Button>
                </div>
            </div>
        </Modal>
    );
}

function ParosAutorizados() {
    const {
        items, loading,
        setSelectedItem, setEditar,
        snackbar, setSnackbar, snackbarText,
        deleteConfirm, setDeleteConfirm, deleteItem,
        setNuevo,
    } = useParosAutorizados();

    const handleSnackClose = (_, reason) => {
        if (reason === 'clickaway') return;
        setSnackbar(false);
    };

    const handleEdit = (item) => {
        setSelectedItem(item);
        setEditar(true);
    };

    return (
        <div className="capacidadesView">
            <Snackbar
                open={snackbar}
                autoHideDuration={3000}
                onClose={handleSnackClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <div className="app-notif app-notif--success">
                    <Check size={20} strokeWidth={2} color="#fff" />
                    <span className="app-notif__msg">{snackbarText}</span>
                    <div className="app-notif__progress" />
                </div>
            </Snackbar>

            <div className="capacidadesView-head">
                <h1 className="titulo">Paros Autorizados</h1>
                <p className="desc">Administra el catálogo de paros autorizados.</p>
            </div>

            <div className="capacidadesView-body">
                <div className="cap-layout">
                    <div className="cap-panel-fields">
                        <div className="cap-card">
                            <div className="cap-card-toolbar">
                                <h3 className="cap-card-title">Paros autorizados</h3>
                            </div>
                            <div className="cap-fields-animate">
                                <div className="cap-fields-grid">
                                    {loading && items.length === 0 && <p className="desc">Cargando...</p>}
                                    {items.map((item) => (
                                        <div key={item.id} className="cap-catalog-card">
                                            <span className="cap-catalog-card-name">{item.nombre}</span>
                                            <div className="cap-catalog-card-actions">
                                                <button className="cap-catalog-btn" onClick={() => handleEdit(item)}><Edit size={16} /></button>
                                                <button className="cap-catalog-btn cap-catalog-btn--delete" onClick={() => setDeleteConfirm(item)}><Trash size={16} /></button>
                                            </div>
                                        </div>
                                    ))}
                                    <button className="cap-catalog-add" onClick={() => setNuevo(true)}>
                                        <CirclePlus size={24} />
                                        <span>Agregar</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <NuevoItem />
            <EditarItem />

            <ConfirmModal
                open={!!deleteConfirm}
                onClose={() => setDeleteConfirm(null)}
                onConfirm={() => deleteItem(deleteConfirm?.codigo)}
                title="Eliminar — Paro autorizado"
            >
                ¿Estás seguro de eliminar <strong>{deleteConfirm?.nombre}</strong>? Esta acción no se puede deshacer.
            </ConfirmModal>
        </div>
    );
}

export default function ParosAutorizadosPage() {
    return (
        <ParosAutorizadosProvider>
            <ParosAutorizados />
        </ParosAutorizadosProvider>
    );
}
